export default "__VITE_ASSET__C0J8CEUH__"